import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export const SourceLink = ({ href, children, testId }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className="guide-source">
    {children}<ArrowUpRight size={13} aria-hidden="true" />
  </a>
);

export const GuideHeading = ({ number, label, title, id }) => (
  <div className="mb-8 flex items-start gap-5">
    <span className="guide-index" aria-hidden="true">{number}</span>
    <div>
      <p className="guide-eyebrow mb-3">{label}</p>
      <h2 id={id} data-testid={id} className="text-base font-semibold md:text-lg">{title}</h2>
    </div>
  </div>
);

export const CounselingLink = ({ country, level, placement, children = "Plan my studies" }) => (
  <Link
    to={`/?country=${encodeURIComponent(country.bookingName)}&level=${level}#book`}
    data-testid={`guide-counseling-${placement}`}
    className="guide-primary-link"
  >
    {children}<ArrowUpRight size={18} aria-hidden="true" />
  </Link>
);

export const LevelSwitch = ({ level, onChange }) => (
  <div role="group" aria-label="Study level" className="guide-level-switch">
    {["undergraduate", "postgraduate"].map((value) => (
      <button
        type="button" key={value} aria-pressed={level === value}
        onClick={() => onChange(value)} data-testid={`guide-level-${value}`}
        className={level === value ? "is-selected" : ""}
      >
        {value === "undergraduate" ? "Undergraduate" : "Postgraduate"}
      </button>
    ))}
  </div>
);